import { Command } from "@/app/common/base/command"

export class RenewQrCodeCommand extends Command {

    public async run(productActionId: string): Promise<void> {
        await this.client.post(`/api/inventory-form/ockto-renew-qr/${productActionId}`)
    }
}
